const TableListeners = ({
  _rows,
  _columns,
  trackKeybindings,
  selectedCell,
  setSelectedCell,
  setIsEditingcell,
}) => {

  const filteredColumns = _columns.filter((column) => !column.internal);

  const onKeyUp = (e) => {

    if (!trackKeybindings || ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].indexOf(e.key) === -1) return;

    e.preventDefault();
    e.stopPropagation();

    if (selectedCell && selectedCell.row != -1) {

      let row = selectedCell.row;
      let column = selectedCell.column;

      // if (!e.shiftKey) return;
      if (e.key === "ArrowUp") row--;
      if (e.key === "ArrowDown") row++;
      if (e.key === "ArrowLeft") column--;
      if (e.key === "ArrowRight") column++;

      if (row < 0) row = 0;
      if (row >= _rows.length) row = _rows.length - 1;
      if (column < 0) column = 0;
      if (column >= filteredColumns.length) column = filteredColumns.length - 1;

      const el = document.getElementById("table-current-cell");
      if(el) el.blur();

      setSelectedCell({ row, column });
      setIsEditingcell(true);

    }

    return false;

  }

  return {
    onKeyUp
  }

}

export default TableListeners;